import React from 'react';
import s from './index.less';
import { useIntl } from 'umi';
import { ColorPresets } from '../../types';
import classNames from 'classnames';
interface ColorProps {
  value: string;
  onChange: (color: string) => void;
}

const Color: React.FC<ColorProps> = (props) => {
  const { value, onChange } = props;
  const colorArray = [
    ColorPresets.RED,
    ColorPresets.ORANGE,
    ColorPresets.YELLOW,
    ColorPresets.GREEN,
    ColorPresets.BLUE,
    ColorPresets.MAGENTA,
    ColorPresets.PURPLE,
    ColorPresets.WHITE,
  ];
  return (
    <div className={s.colorPicker}>
      <div className={s.column}>
        {colorArray.slice(0, 4).map((item: ColorPresets, index: number) => (
          <div
            className={classNames(s.colorBg, item === value ? s.active : '')}
            key={index}
            onClick={() => {
              onChange(item);
            }}
          >
            <div className={s.colorItem} style={{ backgroundColor: item }}></div>
          </div>
        ))}
      </div>

      <div className={s.column}>
        {colorArray.slice(4, 8).map((item: ColorPresets, index: number) => (
          <div
            className={classNames(s.colorBg, item === value ? s.active : '')}
            key={index}
            onClick={() => {
              onChange(item);
            }}
          >
            <div className={s.colorItem} style={{ backgroundColor: item }}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Color;
